var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-container"},[_c('div',{staticClass:"u-left"}),_c('div',{staticClass:"u-text"},[_vm._v(" "+_vm._s(_vm.innerText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }